/**
 * @Author lizuping
 * 根据时间戳+时区转时间
 * @Date: 2022-11-29
 * @Last Modified by: lizuping
 * @Last Modified time: 2023-09-06 18:45:09
 */

import { getLan } from '@/utils/tool';
import dayjs from 'dayjs';
import { engageLabCore } from '@jg/qiankun-micro-tool';

function getUtcTimes() {
  const utc = engageLabCore.organization.takeImmediately().timeZone || 0;
  const t = new Date().getTimezoneOffset() / -60;
  return (utc - t) * 60 * 60 * 1000;
}
export function userFormat(onlyDay = false) {
  let str = getLan().includes('zh') ? 'YYYY/MM/DD' : 'MM/DD/YYYY';

  if (!onlyDay) {
    str += ' HH:mm:ss';
  }
  return str;
}

export function setTimeFormat(time: string | number, onlyDay = false) {
  const str = 'YYYY/DD/MM';
  if (!time) {
    return '';
  }
  return dayjs(Number(time)).format(str);
}
export function setUserTime(time: string | number, onlyDay = false) {
  const str = userFormat(onlyDay);
  if (!time) {
    return '';
  }
  return dayjs(Number(time) + getUtcTimes()).format(str);
}
export function getCST() {
  const t = engageLabCore.organization.takeImmediately().timeZone || 0;
  return t > 0 ? '+' + t : t.toString();
}
export function nowDate() {
  return new Date().getTime() + getUtcTimes();
}
export function getOrgTime(times: number) {
  return times - getUtcTimes();
}
export function nowDateFarmat(str = 'YYYYMMDD') {
  return dayjs(nowDate()).format(str);
}
